const updates = [
  { id: 1, date: '2026-08-01', title: '《流浪地球3》高清版正式上线，4K画质流畅播放', tag: '新片上线' },
  { id: 2, date: '2026-07-30', title: '暑期档专题合集更新：新增 20 部高分动作片', tag: '合集更新' },
  { id: 3, date: '2026-07-28', title: '平台播放引擎升级，加载速度再提升 30%', tag: '系统优化' },
  { id: 4, date: '2026-07-25', title: '韩剧专区热播剧《黑暗荣耀》全季完整上线', tag: '剧集更新' },
  { id: 5, date: '2026-07-22', title: '移动端夜间模式全新上线，暗光观影更舒适', tag: '功能更新' },
  { id: 6, date: '2026-07-20', title: '豆瓣 TOP250 经典影片专区上线，一站式重温经典', tag: '专题上线' },
  { id: 7, date: '2026-07-18', title: '纪录片分类扩充至 200+ 部，涵盖自然、历史、科技', tag: '内容扩充' },
  { id: 8, date: '2026-07-15', title: '视频解码技术升级，低带宽下画质更清晰流畅', tag: '技术升级' },
  { id: 9, date: '2026-07-12', title: '用户收藏夹功能上线，支持跨设备同步观影进度', tag: '新功能' },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-900 text-center mb-2">最新动态</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">平台更新与片源上线的第一手资讯</p>
        <div className="relative pl-8 border-l-2 border-background-200">
          {updates.map((item) => (
            <div key={item.id} className="relative pb-8 last:pb-0">
              <span className="absolute -left-[calc(2rem+5px)] top-0 w-2.5 h-2.5 rounded-full bg-primary-500"></span>
              <div className="text-xs text-foreground-500 mb-1">{item.date}</div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">{item.title}</h3>
              <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">{item.tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}